import styled from 'styled-components';

export const StyledFooter = styled.div`
    display: flex;
    justify-content: center;
    gap: 24px;
    width: 100%;
    padding: 0px 0 24px 0;

    #soft-pull-consent-modal-accept-button {
        padding: 12px 45px;
    }
`;
